import { writable } from 'svelte/store';

export const isLoading = writable(false);
export const currentProgram = writable(null);
export const currentSession = writable(null);
export const currentCircuit = writable(null);
export const currentExercise = writable(null);
export const currentProgress = writable(null);
export const circuitProgress = writable(null);
